import { render, staticRenderFns } from "./ExpirationDateAlert.vue?vue&type=template&id=b026ef66&"
import script from "./ExpirationDateAlert.vue?vue&type=script&lang=ts&"
export * from "./ExpirationDateAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports